// API endpoints
export const API_ENDPOINTS = {
  LOGIN: '/loginCheck',
  LOGOUT: '/logout',
  UPDATE_LOGIN_TIME: '/updatePixUserLoginTime',
  CHECK_SESSION: '/getProfileData',
  VALIDATE_TOKEN: '/validateToken',
  GET_OBJECTS: '/getObjectList',
  GET_OBJECT: '/getObject',
  CREATE_OBJECT: '/createObject',
  UPDATE_OBJECT: '/updateObject',
  DELETE_OBJECT: '/deleteObject',
  UPLOAD_IMAGE: '/uploadImage',
  GET_IMAGES: '/getImageList',
  GET_TALKS: '/getTalkList',
  GET_TALK_MESSAGES: '/getTalkMessageList',
  SEND_MESSAGE: '/sendMessage',
  GET_USERS: '/getPixUserList',
  GET_CATEGORIES: '/getCategoryList',
}

// User roles
export const USER_ROLES = {
  ADMIN: 'admin',
  MASTER: 'master',
  USER: 'user',
  GUEST: 'guest'
}

// User authorities
export const USER_AUTHORITIES = {
  MASTER_USER: 'master_user',
  NORMAL_USER: 'normal_user'
}

// File types
export const FILE_TYPES = {
  IMAGE: 'image',
  VIDEO: 'video',
  DOCUMENT: 'document',
  OTHER: 'other'
}

// Image formats
export const IMAGE_FORMATS = {
  JPG: 'jpg',
  JPEG: 'jpeg',
  PNG: 'png',
  GIF: 'gif',
  BMP: 'bmp',
  WEBP: 'webp'
}

// Video formats
export const VIDEO_FORMATS = {
  MP4: 'mp4',
  AVI: 'avi',
  MOV: 'mov',
  WMV: 'wmv',
  FLV: 'flv',
  WEBM: 'webm'
}

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,
  DEFAULT_PAGE: 1
}

// Validation rules
export const VALIDATION_RULES = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^[\+]?[1-9][\d]{0,15}$/,
  PASSWORD_MIN_LENGTH: 8,
  USERNAME_MIN_LENGTH: 3,
  USERNAME_MAX_LENGTH: 50,
  TITLE_MAX_LENGTH: 200,
  DESCRIPTION_MAX_LENGTH: 1000
}

// Local storage keys
export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER: 'user',
  THEME: 'theme',
  LANGUAGE: 'language',
  SETTINGS: 'settings'
}

// Theme options
export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
  SYSTEM: 'system'
}

// Languages
export const LANGUAGES = {
  EN: 'en',
  JA: 'ja',
  KO: 'ko',
  ZH: 'zh'
}

// Status codes
export const STATUS_CODES = {
  SUCCESS: '1',
  ERROR: '0'
}

// Message types
export const MESSAGE_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
}

// Sort directions
export const SORT_DIRECTIONS = {
  ASC: 'asc',
  DESC: 'desc'
}

// Sort fields
export const SORT_FIELDS = {
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  NAME: 'name',
  TITLE: 'title',
  DATE: 'date'
}
